class HeaderEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const body  = document.querySelector("body")

    const megaMenuArea = document.querySelector(".mouse-action-area")

    // メガメニュー hover開閉
    const megaMenuTriggerAll = document.querySelectorAll(".js-mega-trigger")
    const megaMenuAll = document.querySelectorAll(".js-megaMenu")
    const menuOverlayAll = document.querySelectorAll(".mega-overlay")

    megaMenuArea .addEventListener("mouseover", () => {
      megaMenuAll.forEach(menu => {
        menu.classList.remove("is-hover")
        body.classList.remove("is-scroll")

        megaMenuTriggerAll.forEach(trigger => {
          trigger.classList.remove("is-hover")
        })
      })

    })

    megaMenuTriggerAll.forEach((menu, i) => {
      menu.addEventListener("mouseover", () => {

        body.classList.add("is-scroll")

        megaMenuAll.forEach(item => {
          item.classList.remove("is-hover")
        })

        megaMenuTriggerAll.forEach(item => {
          item.classList.remove("is-hover")
        })

        menu.classList.add("is-hover")

        if(megaMenuAll[i]){
          megaMenuAll[i].classList.add("is-hover")
        }

        if(megaMenuTriggerAll.length === (i + 1)){
          body.classList.remove("is-scroll")
        }

      })



    })

    menuOverlayAll.forEach((overlay, i) => {
      overlay.addEventListener("mouseover", () => {

        body.classList.remove("is-scroll")
        megaMenuAll[i].classList.remove("is-hover")
        megaMenuTriggerAll[i].classList.remove("is-hover")
      })

    })


    if (window.matchMedia('(max-width: 768px)').matches) {
      // ハンバーガーメニュー
      const menuTrigger = document.querySelector(".menu-trigger")
      const menuContainer = document.querySelector(".menu-container")
      const menuOverlay = document.querySelector(".menu-overlay")


      menuTrigger.addEventListener("click", () => {
        body.classList.toggle("is-scroll")
        menuContainer.classList.toggle("is-active")
        menuOverlay.classList.toggle("is-active")
        menuTrigger.classList.toggle("is-active")

      })

      menuOverlay.addEventListener("click", () => {

        body.classList.remove("is-scroll")
        menuContainer.classList.remove("is-active")
        menuOverlay.classList.remove("is-active")
        menuTrigger.classList.remove("is-active")
      })
    }


    const header = document.querySelector(".js-header")
    const menuTrigger = document.querySelector(".menu-trigger")

    window.addEventListener('scroll', (event) => {
      let scroll_y = window.scrollY;

      if(0 < scroll_y){
        header.classList.add("no-top")
        menuTrigger.classList.add("no-top")
      }else{
        header.classList.remove("no-top")
        menuTrigger.classList.remove("no-top")
      }

    });

  }
}
